import { FormattedHTMLMessage } from 'react-intl';
import { useSelector, useDispatch } from 'react-redux';

import CustomThemeButton from '@atlaskit/button/custom-theme-button';
import Modal, {
  ModalTransition,
  ModalTitle,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from '@atlaskit/modal-dialog';

import { LoadingStatus } from 'src/constants/loading-status';
import { useIntl } from 'src/hooks/intl';
import {
  closeUnlinkProjectDialog,
  unlinkJiraProject,
} from 'src/redux/jira/actions';
import {
  getProjectToUnlink,
  getUnlinkJiraProjectStatus,
} from 'src/redux/jira/selectors/repo-page-selectors';
import { getCurrentRepository } from 'src/selectors/repository-selectors';

import messages from './manage-projects-dialog.i18n';

export const UnlinkProjectDialog = () => {
  const dispatch = useDispatch();
  const intl = useIntl();

  const repository = useSelector(getCurrentRepository);
  const projectToUnlink = useSelector(getProjectToUnlink);
  const unlinkProjectStatus = useSelector(getUnlinkJiraProjectStatus);

  const confirm = () => {
    if (projectToUnlink && repository) {
      dispatch(
        unlinkJiraProject({
          repository,
          project: projectToUnlink,
          included: false,
        })
      );
    }
  };

  return (
    <ModalTransition>
      {projectToUnlink ? (
        <Modal
          onClose={() => dispatch(closeUnlinkProjectDialog())}
          width="small"
          shouldCloseOnOverlayClick={false}
          data-testid="manage-projects-dialog-unlink-confirmation-modal"
        >
          <ModalHeader>
            <ModalTitle appearance="warning">
              {intl.formatMessage(messages.unlinkProjectTitle)}
            </ModalTitle>
          </ModalHeader>
          <ModalBody>
            <FormattedHTMLMessage
              {...messages.unlinkProjectDetails}
              values={{
                projectName: projectToUnlink.name,
                projectKey: projectToUnlink.key,
              }}
            />
          </ModalBody>
          <ModalFooter>
            <CustomThemeButton
              appearance="warning"
              onClick={confirm}
              isLoading={unlinkProjectStatus === LoadingStatus.Fetching}
              isDisabled={unlinkProjectStatus === LoadingStatus.Fetching}
              testId="confirm-unlink"
            >
              {intl.formatMessage(messages.unlinkProjectConfirm)}
            </CustomThemeButton>
            <CustomThemeButton
              onClick={() => dispatch(closeUnlinkProjectDialog())}
              isDisabled={unlinkProjectStatus === LoadingStatus.Fetching}
            >
              {intl.formatMessage(messages.unlinkProjectCancel)}
            </CustomThemeButton>
          </ModalFooter>
        </Modal>
      ) : null}
    </ModalTransition>
  );
};
